/**
 * z-index
 *
 * Please, if you add or change something in this list,
 * add or change the same:
 * /css/zIndex.scss
 *
 */
export enum Z_INDEX {
    '--zIndex-overnegative' = -9999,
    '--zIndex-negative' = -10,
    '--zIndex-zero' = 0,
    '--zIndex-layoutFirstItem' = 10,
    '--zIndex-layoutSecondItem' = 20,
    '--zIndex-layoutThirdItem' = 30,
    '--zIndex-layoutFourthItem' = 40,
    '--zIndex-layoutFifthItem' = 50,
    '--zIndex-layoutSixthItem' = 60,
    '--zIndex-layoutSeventhItem' = 70,
    '--zIndex-dropdown' = 80,
    '--zIndex-header' = 90,
    '--zIndex-popup' = 100,
    '--zIndex-tooltip' = 110,
    '--zIndex-overlay' = 1000,
}
